import React, { Component } from "react";
import classnames from "classnames";

import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import * as styles from "./Section.scss";

export interface ISectionProps {
    loading: boolean;
    className?: string;
    children?: React.ReactNode;
}

export class Section extends Component<ISectionProps> {
    public render() {
        const { loading, className, children } = this.props;
        return (
            <>
                <LoadingIndicator visible={loading} />
                <div
                    className={classnames(
                        styles.section,
                        className,
                        loading && styles.loading,
                    )}
                >
                    {children}
                </div>
            </>
        );
    }
}
